module.exports = __webpack_public_path__ + "img/car_sendai16.6109b4ad.jpg";